import { createStyles, makeStyles, Theme } from "@material-ui/core";

const buttonBgColor = "rgba(54, 123, 245, 0.2)";
const boxShadow = "0 0 8px 0 rgba(0, 0, 0, 0.08)";
export const inputWidth = "400px";

export default makeStyles((theme: Theme) =>
	createStyles({
		icon: {
			borderRadius: 5,
			"&:hover": {
				backgroundColor: buttonBgColor,
			},
		},
		popoverPaper: {
			border: "none",
			boxShadow,
			minWidth: "514px",
			minHeight: "491px",
		},
		inputRoot: {
			boxShadow,
			minHeight: "56px",
			padding: `${theme.spacing(1.5)}px ${theme.spacing(3)}px`,
			borderLeft: `1px solid ${theme.palette.tableDivider.main}`,
			borderBottom: `1px solid ${theme.palette.tableDivider.main}`,
			borderRight: `1px solid ${theme.palette.tableDivider.main}`,
		},
		inputField: {
			marginLeft: "15px",
			width: "100%",
		},
		sendIcon: {
			padding: 0,
			"&:hover": {
				backgroundColor: buttonBgColor,
			},
		},
		messagesRoot: {
			backgroundColor: "#f5f8f9",
			display: "flex",
			flexDirection: "column",
			width: "100%",
			maxHeight: "440px",
			justifyContent: "space-between",
		},

		gradientTop: {
			background: "linear-gradient( #f5f8f9, #ffffff )",
			minHeight: "20px",
			display: "flex",
			justifyContent: "flex-end",
			padding: "10px",
		},
		messagesContainer: {
			height: "391px",
			overflowY: "scroll",
		},
		messagesPaper: {
			padding: theme.spacing(2),
			marginLeft: "32px",
			position: "relative",
			zIndex: 0,
		},
		messageStyle: {
			display: "flex",
			padding: theme.spacing(2),
			paddingBottom: 0,
			alignItems: "center",
			position: "relative",
			zIndex: 1,
			justifyContent: "space-between",
		},
		avatarRoot: {
			zIndex: 2,
			marginLeft: "-40px",
		},
		contentMessage: {
			fontWeight: 300,
			fontSize: "1rem",
			letterSpacing: "0.15px",
			whiteSpace: "pre-line",
		},
		contentContainer: {
			maxWidth: inputWidth,
			wordWrap: "break-word",
		},
		readMoreText: {
			color: theme.palette.primary.main,
			"&:hover": {
				backgroundColor: "transparent",
			},
			padding: 0,
		},
		smallFont: {
			fontSize: ".8rem",
		},
		smallFontSecondary: {
			fontSize: ".8rem",
			color: "#969392",
		},
		mentionsPopover: {
			border: "none",
		},
	})
);
